var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "143.89453pt",
    height: "359.17578pt",
    viewBox: "0 0 143.89453 359.17578",
    id: "svg605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2.21875,2.71875 c -0.074219,0.175781 -0.25,0.265625 -0.53125,0.265625 -0.085938,0 -0.167969,-0.011719 -0.25,-0.03125 L 1.03125,2.84375 C 0.570312,2.71875 0.265625,2.472656 0.109375,2.109375 0.0351562,1.929688 0,1.726562 0,1.5 V 0.703125 c 0,-0.148437 0.0664062,-0.21875 0.203125,-0.21875 0.132813,0 0.203125,0.070313 0.203125,0.21875 v 0.90625 c 0,0.175781 0.054688,0.34375 0.171875,0.5 0.125,0.15625 0.273437,0.253906 0.453125,0.296875 L 1.4375,2.515625 C 1.53125,2.546875 1.609375,2.5625 1.671875,2.5625 1.929688,2.5625 2.0625,2.390625 2.0625,2.046875 v -0.375 c 0,-0.136719 0.066406,-0.203125 0.203125,-0.203125 0.132813,0 0.203125,0.066406 0.203125,0.203125 V 2.15625 c 0,0.25 0.101562,0.460938 0.3125,0.640625 0.09375,0.082031 0.195312,0.140625 0.3125,0.171875 0.070312,0.00781 0.132812,0.015625 0.1875,0.015625 0.289062,0 0.4375,-0.167969 0.4375,-0.5 V 1.6875 c 0,-0.136719 0.066406,-0.203125 0.203125,-0.203125 0.132813,0 0.203125,0.066406 0.203125,0.203125 V 2.609375 C 4.125,2.921875 3.976562,3.15625 3.6875,3.3125 3.5625,3.382812 3.429688,3.421875 3.296875,3.421875 3.222656,3.421875 3.15625,3.410156 3.09375,3.390625 2.644531,3.273438 2.351562,3.050781 2.21875,2.71875 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.40625,1.59375 c 0,0.425781 0.207031,0.695312 0.625,0.8125 L 1.4375,2.515625 C 1.519531,2.546875 1.597656,2.5625 1.671875,2.5625 1.929688,2.5625 2.0625,2.390625 2.0625,2.046875 V 1.40625 L 1.03125,1.125 C 0.96875,1.113281 0.914062,1.109375 0.875,1.109375 0.738281,1.109375 0.625,1.15625 0.53125,1.25 0.445312,1.34375 0.40625,1.457031 0.40625,1.59375 Z M 0,1.484375 C 0,1.191406 0.148438,0.960938 0.453125,0.796875 0.585938,0.722656 0.722656,0.6875 0.859375,0.6875 c 0.050781,0 0.109375,0.003906 0.171875,0.015625 L 2.265625,1.03125 c 0.457031,0.125 0.84375,0.332031 1.15625,0.625 C 3.765625,1.976562 4,2.398438 4.125,2.921875 c 0,0.00781 0,0.023437 0,0.046875 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 C 3.804688,3.171875 3.738281,3.125 3.71875,3.03125 3.6875,2.800781 3.601562,2.570312 3.46875,2.34375 3.207031,1.925781 2.875,1.660156 2.46875,1.546875 V 2.15625 C 2.46875,2.394531 2.394531,2.59375 2.25,2.75 2.101562,2.90625 1.910156,2.984375 1.671875,2.984375 1.585938,2.984375 1.507812,2.972656 1.4375,2.953125 L 1.03125,2.84375 C 0.550781,2.707031 0.242188,2.472656 0.109375,2.140625 0.0351562,1.960938 0,1.742188 0,1.484375 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.03125,2.921875 0.09375,1.71875 C 0.03125,1.6875 0,1.628906 0,1.546875 0,1.492188 0.0195312,1.445312 0.0625,1.40625 0.101562,1.363281 0.15625,1.34375 0.21875,1.34375 l 3.703125,0.140625 c 0.132813,0 0.203125,0.066406 0.203125,0.203125 0,0.144531 -0.074219,0.21875 -0.21875,0.21875 l -2.9375,-0.125 1.8125,1.109375 c 0.070312,0.039063 0.109375,0.097656 0.109375,0.171875 0,0.132812 -0.0625,0.207031 -0.1875,0.21875 l -1.75,0.125 3.0625,1.515625 C 4.085938,4.960938 4.125,5.023438 4.125,5.109375 4.125,5.242188 4.054688,5.3125 3.921875,5.3125 c -0.03125,0 -0.0625,-0.00781 -0.09375,-0.015625 L 0.109375,3.453125 C 0.0351562,3.410156 0,3.347656 0,3.265625 0,3.128906 0.0625,3.0625 0.1875,3.0625 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.40625,2.40625 c 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 C 0.0664062,2.609375 0,2.539062 0,2.40625 V 0.640625 C 0,0.578125 0.0195312,0.53125 0.0625,0.5 0.101562,0.46875 0.148438,0.460938 0.203125,0.484375 L 3.96875,1.5 C 4.070312,1.519531 4.125,1.582031 4.125,1.6875 c 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 -0.023437,0 -0.042969,0 -0.0625,0 L 0.40625,0.96875 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2.0625,2.53125 v -1.125 L 0.40625,0.96875 v 1.4375 c 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 C 0.0664062,2.609375 0,2.539062 0,2.40625 V 0.640625 C 0,0.578125 0.0195312,0.53125 0.0625,0.5 0.101562,0.46875 0.148438,0.460938 0.203125,0.484375 l 3.71875,1 C 4.054688,1.515625 4.125,1.601562 4.125,1.75 v 1.640625 c 0,0.144531 -0.070312,0.21875 -0.203125,0.21875 -0.136719,0 -0.203125,-0.074219 -0.203125,-0.21875 V 1.84375 l -1.25,-0.328125 V 2.53125 c 0,0.132812 -0.070312,0.203125 -0.203125,0.203125 C 2.128906,2.734375 2.0625,2.664062 2.0625,2.53125 Z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.921875,1.484375 C 4.054688,1.515625 4.125,1.601562 4.125,1.75 v 1.28125 c 0,0.21875 -0.09375,0.40625 -0.28125,0.5625 -0.179688,0.164062 -0.375,0.25 -0.59375,0.25 -0.054688,0 -0.105469,-0.00781 -0.15625,-0.015625 l -2.0625,-0.5625 C 0.34375,3.078125 0,2.628906 0,1.921875 V 0.640625 C 0,0.578125 0.0195312,0.53125 0.0625,0.5 0.101562,0.46875 0.148438,0.460938 0.203125,0.484375 Z M 3.71875,1.84375 0.40625,0.96875 v 1.0625 c 0,0.175781 0.054688,0.34375 0.171875,0.5 0.125,0.15625 0.273437,0.257812 0.453125,0.3125 l 2.0625,0.546875 c 0.050781,0.019531 0.101562,0.03125 0.15625,0.03125 0.132812,0 0.242188,-0.054687 0.328125,-0.15625 0.09375,-0.09375 0.140625,-0.210937 0.140625,-0.34375 z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.6875,4.109375 H 0 V 0.25 c 0.175781,-0.011719 0.34375,0.015625 0.5,0.078125 0.257812,0.101563 0.515625,0.257813 0.765625,0.46875 0.257813,0.21875 0.554687,0.53125 0.890625,0.9375 0.519531,0.632813 0.929688,1.0625 1.234375,1.28125 0.300781,0.226563 0.585937,0.34375 0.859375,0.34375 0.289062,0 0.53125,-0.105469 0.71875,-0.3125 0.195312,-0.199219 0.296875,-0.460937 0.296875,-0.78125 0,-0.34375 -0.105469,-0.621094 -0.3125,-0.828125 C 4.742188,1.226562 4.457031,1.125 4.09375,1.125 l 0.078125,-0.75 c 0.550781,0.050781 0.96875,0.242188 1.25,0.578125 0.289063,0.332031 0.4375,0.773437 0.4375,1.328125 0,0.5625 -0.15625,1.003906 -0.46875,1.328125 -0.304687,0.320313 -0.6875,0.484375 -1.15625,0.484375 -0.230469,0 -0.460937,-0.046875 -0.6875,-0.140625 C 3.328125,3.859375 3.09375,3.695312 2.84375,3.46875 2.59375,3.25 2.25,2.882812 1.8125,2.375 1.445312,1.945312 1.203125,1.671875 1.078125,1.546875 0.953125,1.421875 0.820312,1.320312 0.6875,1.25 Z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2.875,0.34375 c 0.695312,0 1.253906,0.066406 1.671875,0.203125 0.414063,0.144531 0.738281,0.359375 0.96875,0.640625 0.226563,0.28125 0.34375,0.628906 0.34375,1.046875 0,0.320313 -0.0625,0.597656 -0.1875,0.828125 C 5.546875,3.300781 5.363281,3.5 5.125,3.65625 4.882812,3.8125 4.59375,3.929688 4.25,4.015625 c -0.335938,0.082031 -0.792969,0.125 -1.375,0.125 -0.679688,0 -1.230469,-0.074219 -1.65625,-0.21875 C 0.800781,3.785156 0.476562,3.578125 0.25,3.296875 c -0.2304688,-0.273437 -0.34375,-0.625 -0.34375,-1.0625 0,-0.5625 0.195312,-1 0.59375,-1.3125 C 0.988281,0.535156 1.78125,0.34375 2.875,0.34375 Z m 0,0.734375 c -0.960938,0 -1.601562,0.109375 -1.921875,0.328125 -0.3125,0.226562 -0.46875,0.503906 -0.46875,0.828125 0,0.332031 0.160156,0.609375 0.484375,0.828125 0.320312,0.226562 0.957031,0.34375 1.90625,0.34375 0.96875,0 1.609375,-0.117188 1.921875,-0.34375 0.3125,-0.21875 0.46875,-0.496094 0.46875,-0.828125 0,-0.335937 -0.140625,-0.59375 -0.421875,-0.78125 -0.355469,-0.25 -1.011719,-0.375 -1.96875,-0.375 z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0.59375 H 5.84375 V 1.375 H 0.6875 V 4.25 H 0 Z m 0,0",
    id: "path9"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g605",
    transform: "translate(-217.37109,-35.933594)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,0.00250733 h -33.4375 m -4.958333,0 h -4.963542 m -4.958333,0 h -4.958334 m -4.963541,0 h -24.958334 m -4.958333,0 h -4.963542 m -4.958333,0 h -4.958333 m -5.11979,0 h -24.80208 m -4.95834,0 h -4.95833 m -5.125,0 h -4.95833",
    transform: "matrix(0.75,0,0,0.75,361.08,394.91999)",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 323.52083,526.5625 H 290.07812 V 499.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,0.00186733 V -4.961674 m 0,-4.958334 v -4.958333 m 0,-4.963542 v -24.958333 m 0,-4.958333 v -4.963542 m 0,-4.958333 v -4.958334 m 0,-4.963541 v -24.958334 m 0,-4.958333 v -4.963544 m 0,-4.95833 v -4.95833 m 0,-4.95834 v -24.96354 m 0,-4.95833 v -4.95834 m 0,-4.96354 v -5.11979 m 0,-4.95833 v -24.80209 m 0,-4.95833 v -5.11979 m 0,-4.95833 v -4.96355 m 0,-4.95833 v -24.95833 m 0,-4.96354 v -4.95834 m 0,-4.95833 v -4.96354 m 0,-4.95834 v -24.95833 m 0,-4.96354 v -4.95833 m 0,-4.95834 v -4.96354 m 0,-4.95833 v -24.95834 m 0,-4.96354 v -4.95833 m 0,-4.95833 v -4.95834 m 0,-5.125 v -24.79687 m 0,-4.95834 v -4.96354 m 0,-5.11979 v -4.95833",
    transform: "matrix(0.75,0,0,0.75,217.55999,370.44001)",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 290.07812,75.682297 V 48.161464 h 33.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,0.00146367 H 4.957489 m 5.125,0 h 4.958333 m 4.958334,0 h 24.802083 m 5.119792,0 h 4.958333 m 4.958333,0 h 4.963542 m 4.958333,0 h 24.958334 m 4.963541,0 h 4.958333 m 4.95833,0 h 4.96355",
    transform: "matrix(0.75,0,0,0.75,246.36001,36.119996)",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 448,48.161464 h 33.4375 v 27.520833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,6.31333e-4 V 4.958965 m 0,5.119791 v 4.963542 m 0,4.958333 v 24.796875 m 0,5.125 v 4.958334 m 0,4.958333 v 4.958333 m 0,4.963542 v 24.958333 m 0,4.958334 v 4.963545 m 0,4.95833 v 4.95833 m 0,4.96355 v 24.95833 m 0,4.95833 v 4.96354 m 0,4.95834 v 4.95833 m 0,4.96354 v 24.95833 m 0,4.95834 v 4.96354 m 0,4.95833 v 5.11979 m 0,4.95834 v 24.80208 m 0,4.95833 v 5.1198 m 0,4.96354 v 4.95833 m 0,4.95833 v 24.96355 m 0,4.95833 v 4.95833 m 0,4.95834 v 4.96354 m 0,4.95833 v 24.95833 m 0,4.96355 v 4.95833 m 0,4.95833 v 4.96354 m 0,4.95834 v 24.95833 m 0,4.96354 v 4.95834 m 0,4.95833 v 4.96354",
    transform: "matrix(0.75,0,0,0.75,361.08,60.479995)",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 481.4375,499.04167 V 526.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 361.07812,36.121094 -0.11718,10.558594 V 36.121094 Z m 0,0",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 361.07812,36.121094 v 10.558594 h -0.11718 z m 0,0",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.96094,46.558594 -1.67969,0.121094 v -0.121094 z m 0,0",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.96094,46.558594 v 0.121094 h -1.67969 z m 0,0",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 359.28125,45.238281 -0.12109,1.441407 v -1.441407 z m 0,0",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 359.28125,45.238281 v 1.441407 h -0.12109 z m 0,0",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.76172,37.921875 -1.32031,0.117187 v -0.117187 z m 0,0",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 353.76172,37.921875 v 0.117187 h -1.32031 z m 0,0",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.96094,36.121094 -8.51953,0.238281 v -0.238281 z m 0,0",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.96094,36.121094 v 0.238281 h -8.51953 z m 0,0",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 352.44141,36.121094 -0.1211,1.917968 v -1.917968 z m 0,0",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 352.44141,36.121094 v 1.917968 h -0.1211 z m 0,0",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00146367 H 11.67749 M 0.161865,0.319172 H 11.52124 M 11.67749,0.00146367 V 14.079589 M 11.52124,0.319172 V 13.91813 m 0.15625,0.161459 H 9.120198 M 11.52124,13.91813 H 9.281657 M 9.120198,14.079589 V 12.157714 M 9.281657,13.91813 V 12.157714 M 4.06667e-4,0.00146367 V 2.558755 M 0.161865,0.319172 V 2.402505 M 4.06667e-4,2.558755 H 1.922282",
    transform: "matrix(0.75,0,0,0.75,352.32001,36.119996)",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.92187,50.562505 h 1.76042 v 0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,-0.00228633 H -0.159801 M -3.040009,-9.601245 v 0.963542 m 0,0.15625 v 0.963542 m 0,0.15625 v 0.963541 m 0,0.317709 v 0.958333 m 0,0.161458 v 0.958334 m 0,0.161458 v 0.958333",
    transform: "matrix(0.75,0,0,0.75,359.28001,45.239996)",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 476,57.760422 v 0.802083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,-0.00228633 H 0.798533 m 0.322916,0 h 0.958334 m 0.161458,0 h 0.958333 m 0.161459,0 h 0.958333 m 0.322917,0 h 0.958333 m 0.161458,0 h 0.958334",
    transform: "matrix(0.75,0,0,0.75,353.28001,45.239996)",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 478.07812,60.317714 h 0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.55859,36.121094 0.24219,10.558594 V 36.121094 Z m 0,0",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.55859,36.121094 v 10.558594 h 0.24219 z m 0,0",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.80078,46.558594 1.55859,0.121094 v -0.121094 z m 0,0",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.80078,46.558594 v 0.121094 h 1.55859 z m 0,0",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 219.35937,45.238281 0.24219,1.441407 v -1.441407 z m 0,0",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 219.35937,45.238281 v 1.441407 h 0.24219 z m 0,0",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.87891,37.921875 1.32031,0.117187 v -0.117187 z m 0,0",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.87891,37.921875 v 0.117187 h 1.32031 z m 0,0",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.80078,36.121094 8.39844,0.238281 v -0.238281 z m 0,0",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.80078,36.121094 v 0.238281 h 8.39844 z m 0,0",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 226.19922,36.121094 0.24219,1.917968 v -1.917968 z m 0,0",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 226.19922,36.121094 v 1.917968 h 0.24219 z m 0,0",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.001862,0.00146367 h -11.84375 M -0.321055,0.319172 H -11.518971 M -11.841888,0.00146367 V 14.079589 M -11.518971,0.319172 V 13.91813 m -0.322917,0.161459 h 2.723958 m -2.401041,-0.161459 h 2.078125 m 0.322916,0.161459 V 12.157714 M -9.440846,13.91813 V 12.157714 M 0.001862,0.00146367 V 2.558755 M -0.321055,0.319172 v 2.083333 m 0.322917,0.15625 h -2.083333",
    transform: "matrix(0.75,0,0,0.75,226.44001,36.119996)",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.59896,50.562505 h -1.76042 v 0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,-0.00228633 H 0.322072 M 3.202281,-9.601245 v 0.963542 m 0,0.15625 v 0.963542 m 0,0.15625 v 0.963541 m 0,0.317709 v 0.958333 m 0,0.161458 v 0.958334 m 0,0.161458 v 0.958333",
    transform: "matrix(0.75,0,0,0.75,219.36001,45.239996)",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 295.68229,57.760422 v 0.802083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,-0.00228633 h -0.958333 m -0.161459,0 h -0.958333 m -0.322917,0 h -0.958333 m -0.161458,0 h -0.958334 m -0.161458,0 h -0.958333 m -0.322917,0 h -0.958333",
    transform: "matrix(0.75,0,0,0.75,225.48001,45.239996)",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 293.59896,60.317714 h -0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 361.07812,394.92187 -0.11718,-10.5625 v 10.5625 z m 0,0",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 361.07812,394.92187 v -10.5625 h -0.11718 z m 0,0",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.96094,384.48047 -1.67969,-0.1211 v 0.1211 z m 0,0",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.96094,384.48047 v -0.1211 h -1.67969 z m 0,0",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 359.28125,385.80078 -0.12109,-1.44141 v 1.44141 z m 0,0",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 359.28125,385.80078 v -1.44141 h -0.12109 z m 0,0",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 353.76172,393.12109 352.44141,393 v 0.12109 z m 0,0",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 353.76172,393.12109 V 393 h -1.32031 z m 0,0",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.96094,394.92187 -8.51953,-0.24218 v 0.24218 z m 0,0",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 360.96094,394.92187 v -0.24218 h -8.51953 z m 0,0",
    id: "path63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 352.44141,394.92187 352.32031,393 v 1.92187 z m 0,0",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 352.44141,394.92187 V 393 h -0.1211 z m 0,0",
    id: "path65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00250733 H 11.67749 M 0.161865,-0.320409 H 11.52124 m 0.15625,0.32291633 V -14.080826 m -0.15625,13.760417 v -13.598959 m 0.15625,-0.161458 H 9.120198 m 2.401042,0.161458 H 9.281657 m -0.161459,-0.161458 v 1.921875 m 0.161459,-1.760417 v 1.760417 M 4.06667e-4,0.00250733 V -2.559993 M 0.161865,-0.320409 V -2.398534 M 4.06667e-4,-2.559993 H 1.922282",
    transform: "matrix(0.75,0,0,0.75,352.32001,394.91999)",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.92187,524.16146 h 1.76042 V 524",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,0.001023 H -0.159801 M -3.040009,9.599981 V 8.641648 m 0,-0.161458 V 7.521856 m 0,-0.322916 V 6.402065 m 0,-0.322917 V 5.120815 m 0,-0.161459 V 4.001023 m 0,-0.322917 V 2.719773",
    transform: "matrix(0.75,0,0,0.75,359.28001,385.80001)",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 476,516.95834 v -0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,0.001023 H 0.798533 m 0.322916,0 h 0.958334 m 0.161458,0 h 0.958333 m 0.161459,0 h 0.958333 m 0.322917,0 h 0.958333 m 0.161458,0 h 0.958334",
    transform: "matrix(0.75,0,0,0.75,353.28001,385.80001)",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 478.07812,514.40105 h 0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.55859,394.92187 0.24219,-10.5625 v 10.5625 z m 0,0",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.55859,394.92187 v -10.5625 h 0.24219 z m 0,0",
    id: "path73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.80078,384.48047 1.55859,-0.1211 v 0.1211 z m 0,0",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.80078,384.48047 v -0.1211 h 1.55859 z m 0,0",
    id: "path75"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 219.35937,385.80078 0.24219,-1.44141 v 1.44141 z m 0,0",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 219.35937,385.80078 v -1.44141 h 0.24219 z m 0,0",
    id: "path77"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 224.87891,393.12109 226.19922,393 v 0.12109 z m 0,0",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 224.87891,393.12109 V 393 h 1.32031 z m 0,0",
    id: "path79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.80078,394.92187 8.39844,-0.24218 v 0.24218 z m 0,0",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 217.80078,394.92187 v -0.24218 h 8.39844 z m 0,0",
    id: "path81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 226.19922,394.92187 226.44141,393 v 1.92187 z m 0,0",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 226.19922,394.92187 V 393 h 0.24219 z m 0,0",
    id: "path83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.001862,0.00250733 h -11.84375 M -0.321055,-0.320409 h -11.197916 m -0.322917,0.32291633 V -14.080826 m 0.322917,13.760417 v -13.598959 m -0.322917,-0.161458 h 2.723958 m -2.401041,0.161458 h 2.078125 m 0.322916,-0.161458 v 1.921875 m -0.322916,-1.760417 v 1.760417 M 0.001862,0.00250733 V -2.559993 m -0.322917,2.239584 v -2.078125 m 0.322917,-0.161459 h -2.083333",
    transform: "matrix(0.75,0,0,0.75,226.44001,394.91999)",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.59896,524.16146 h -1.76042 V 524",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,0.001023 H 0.322072 M 3.202281,9.599981 V 8.641648 m 0,-0.161458 V 7.521856 m 0,-0.322916 V 6.402065 m 0,-0.322917 V 5.120815 m 0,-0.161459 V 4.001023 m 0,-0.322917 V 2.719773",
    transform: "matrix(0.75,0,0,0.75,219.36001,385.80001)",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 295.68229,516.95834 v -0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,0.001023 h -0.958333 m -0.161459,0 h -0.958333 m -0.322917,0 h -0.958333 m -0.161458,0 h -0.958334 m -0.161458,0 h -0.958333 m -0.322917,0 h -0.958333",
    transform: "matrix(0.75,0,0,0.75,225.48001,385.80001)",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 293.59896,514.40105 h -0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 388.80208,142.23959 v 94.07812 h -5.92187 v -94.07812 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,-4.16333e-4 -0.478557,-0.641041 -1.28064,-1.120208 l -0.796875,-0.317708 -0.802083,-0.161459 -0.802084,0.161459 -0.796875,0.317708 -0.802083,0.479167 -0.479167,0.640624667",
    transform: "matrix(0.75,0,0,0.75,291.48001,106.68)",
    id: "path91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,-0.00229333 0.47937,0.638332 1.281453,1.117498 2.078328,1.440415 2.880412,1.601873 3.682495,1.440415 4.47937,1.117498 5.281453,0.638332 5.76062,-0.00229333",
    transform: "matrix(0.75,0,0,0.75,287.16,177.24)",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 385.76042,142.23959 v 94.07812",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path93"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g93"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 292.79901,
    y: 128.6387,
    id: "use93"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6732.2355,-15119.902 c 9.0089,3.804 13.6134,12.812 13.6134,27.227 0,4.404 -0.6006,8.608 -1.6016,12.812 l -5.6055,20.821 c -6.4063,23.623 -19.0187,39.238 -37.6371,47.246 -9.2091,3.804 -19.6193,5.606 -31.2308,5.606 h -40.8402 c -7.6075,0 -11.2111,-3.403 -11.2111,-10.41 0,-6.807 3.6036,-10.411 11.2111,-10.411 h 46.4458 c 9.0088,0 17.6173,-2.802 25.6252,-8.808 8.0079,-6.407 13.0128,-14.014 15.215,-23.223 l 5.6055,-20.821 c 1.6016,-4.804 2.4024,-8.808 2.4024,-12.012 0,-13.213 -8.8087,-20.019 -26.426,-20.019 h -19.219 c -7.0069,0 -10.4102,-3.404 -10.4102,-10.411 0,-6.806 3.4033,-10.41 10.4102,-10.41 h 24.8245 c 12.8126,0 23.6233,-5.205 32.8323,-16.016 4.2042,-4.804 7.2071,-10.009 8.8087,-16.015 0.4004,-3.604 0.8008,-6.807 0.8008,-9.61 0,-14.814 -8.6085,-22.422 -25.6252,-22.422 h -40.8403 c -7.0069,0 -10.4103,-3.403 -10.4103,-10.41 0,-6.807 3.4034,-10.41 10.4103,-10.41 h 47.2466 c 16.0158,0 28.0276,7.607 36.0355,22.422 3.6035,6.406 5.6055,13.213 5.6055,20.019 0,3.804 -0.6006,7.207 -1.6016,10.411 -6.0059,23.022 -17.4171,38.037 -34.4339,44.844 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path94"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g94"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 292.79901,
    y: 131.63388,
    id: "use94"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6827.9298,-15027.011 c 21.8215,0 35.6351,-10.61 41.6411,-32.031 l 5.6055,-20.821 c 1.6016,-4.204 2.4023,-8.208 2.4023,-12.012 0,-13.213 -8.8086,-20.019 -26.426,-20.019 h -32.8324 l -14.4142,52.852 c -0.6006,3.203 -0.8008,6.006 -0.8008,8.008 0,7.007 2.4024,12.812 7.2071,17.617 4.8048,4.404 10.6105,6.406 17.6174,6.406 z m -5.6055,20.821 c -15.0148,0 -26.8265,-7.608 -35.2347,-23.223 -3.8038,-6.807 -5.6056,-13.814 -5.6056,-20.821 0,-2.602 0.2002,-5.605 0.8008,-8.808 l 16.8166,-63.263 c 6.4063,-23.423 17.0168,-43.242 32.0316,-59.258 16.4161,-17.617 38.0375,-29.629 64.8639,-36.035 0.4004,0 1.2012,0 2.4024,0 6.8067,0 10.4102,3.603 10.4102,10.41 0,6.006 -2.4023,9.409 -7.2071,10.41 -11.8116,1.602 -23.6233,6.006 -35.2347,12.813 -21.4211,13.413 -35.0345,30.43 -40.8403,51.25 h 31.2308 c 12.2121,0 22.4221,3.804 30.43,11.211 8.0079,7.608 12.0119,17.417 12.0119,29.629 0,4.405 -0.6006,8.409 -1.6016,12.012 l -5.6055,20.821 c -7.007,24.624 -19.0188,40.44 -36.0356,47.246 -9.209,3.804 -20.4201,5.606 -33.6331,5.606 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path95"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g95"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 292.79901,
    y: 134.51384,
    id: "use95"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7043.7425,-15110.293 -61.6608,99.298 c -1.6015,3.203 -4.6045,4.805 -8.8086,4.805 -2.8028,0 -5.2052,-1.001 -7.2071,-3.203 -2.2022,-2.002 -3.2032,-4.805 -3.2032,-8.008 l 7.2071,-189.787 c 0,-6.807 3.4034,-10.41 10.4103,-10.41 7.4073,0 11.211,3.803 11.211,11.211 l -6.4063,150.548 56.856,-92.892 c 2.002,-3.603 5.005,-5.605 8.8087,-5.605 6.8067,0 10.6105,3.203 11.2111,9.609 l 6.4063,89.689 77.6765,-156.955 c 2.002,-3.603 5.2052,-5.605 9.6095,-5.605 6.8067,0 10.4103,3.603 10.4103,10.41 0,1.601 -0.4004,3.203 -0.8008,4.805 l -94.4931,190.587 c -2.2022,3.804 -5.4054,5.606 -9.6095,5.606 -7.0069,0 -10.4103,-3.203 -10.4103,-9.61 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path96"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g96"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 292.91806,
    y: 143.04013,
    id: "use96"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7454.147,-15033.017 c 6.8067,0 10.4103,3.604 10.4103,10.411 0,7.007 -3.6036,10.41 -10.4103,10.41 h -90.4892 c -3.2031,0 -5.6055,-1.001 -7.2071,-3.203 -1.6016,-2.002 -2.002,-4.405 -0.8008,-7.207 l 52.0513,-192.99 c 1.001,-5.206 4.2042,-8.008 9.6095,-8.008 6.8067,0 10.4103,3.603 10.4103,10.41 0,1.201 0,2.202 0,3.203 l -47.2466,176.974 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path97"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g97"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 292.91806,
    y: 146.03529,
    id: "use97"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7614.1047,-15117.9 h -57.6569 l -22.4221,84.883 h 73.6727 c 6.8067,0 10.4102,3.604 10.4102,10.411 0,7.007 -3.6035,10.41 -10.4102,10.41 h -90.4892 c -3.2032,0 -5.6056,-1.001 -7.2071,-3.203 -1.6016,-2.002 -2.002,-4.405 -0.8008,-7.207 l 51.2505,-190.588 c 1.6016,-6.807 6.0059,-10.41 13.6134,-10.41 h 84.0829 c 7.4073,0 11.211,3.603 11.211,10.41 0,7.007 -3.8037,10.41 -11.211,10.41 h -79.2782 l -16.8165,64.063 h 52.0513 c 6.8067,0 10.4102,3.604 10.4102,10.411 0,7.006 -3.6035,10.41 -10.4102,10.41 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path98"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g98"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 292.91806,
    y: 148.91527,
    id: "use98"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7707.9972,-15213.194 c 1.6016,-6.807 6.0059,-10.41 13.6134,-10.41 h 65.6647 c 11.2111,0 20.8206,4.804 28.8285,14.414 8.4082,9.209 12.8126,19.219 12.8126,30.43 0,2.803 -0.4004,5.405 -0.8008,8.008 l -28.8284,105.704 c -9.6095,35.235 -32.6322,52.852 -68.8679,52.852 h -65.6647 c -3.2032,0 -5.6055,-1.001 -7.2071,-3.203 -1.6016,-2.002 -2.002,-4.405 -0.8008,-7.207 z m 18.4182,10.41 -44.8442,169.767 h 54.4536 c 9.0089,0 17.6174,-2.802 25.6253,-8.808 8.0079,-6.407 13.213,-14.014 16.0158,-23.223 l 28.0276,-105.704 c 1.001,-2.603 1.6016,-5.205 1.6016,-8.008 0,-6.807 -2.8028,-12.412 -8.0079,-16.817 -4.8048,-4.804 -10.8107,-7.207 -17.6174,-7.207 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 396.16146,190.88021 v 14.07813 h -5.92188 v -14.07813 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 388.80208,338.23959 v 94.23958 h -5.92187 v -94.23958 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,0.001053 -0.479167,-0.640625 -0.802083,-0.479167 -0.796875,-0.322916 -0.802083,-0.15625 -0.802084,0.15625 -0.796875,0.322916 -0.802083,0.479167 -0.479167,0.640625",
    transform: "matrix(0.75,0,0,0.75,291.48001,253.79999)",
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,-0.00229333 0.47937,0.638332 1.281453,1.117498 2.078328,1.440415 2.880412,1.601873 3.682495,1.440415 4.47937,1.117498 5.281453,0.638332 5.76062,-0.00229333",
    transform: "matrix(0.75,0,0,0.75,287.16,324.24)",
    id: "path103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 385.76042,338.23959 v 94.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path104"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g104"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 292.79901,
    y: 275.63821,
    id: "use104"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 14265.861,-15119.902 c 9.009,3.804 13.613,12.812 13.613,27.227 0,4.404 -0.601,8.608 -1.602,12.812 l -5.605,20.821 c -6.406,23.623 -19.019,39.238 -37.637,47.246 -9.209,3.804 -19.619,5.606 -31.231,5.606 h -40.84 c -7.608,0 -11.211,-3.403 -11.211,-10.41 0,-6.807 3.603,-10.411 11.211,-10.411 h 46.446 c 9.008,0 17.617,-2.802 25.625,-8.808 8.008,-6.407 13.013,-14.014 15.215,-23.223 l 5.605,-20.821 c 1.602,-4.804 2.403,-8.808 2.403,-12.012 0,-13.213 -8.809,-20.019 -26.426,-20.019 h -19.219 c -7.007,0 -10.411,-3.404 -10.411,-10.411 0,-6.806 3.404,-10.41 10.411,-10.41 h 24.824 c 12.813,0 23.624,-5.205 32.833,-16.016 4.204,-4.804 7.207,-10.009 8.808,-16.015 0.401,-3.604 0.801,-6.807 0.801,-9.61 0,-14.814 -8.608,-22.422 -25.625,-22.422 h -40.84 c -7.007,0 -10.411,-3.403 -10.411,-10.41 0,-6.807 3.404,-10.41 10.411,-10.41 h 47.246 c 16.016,0 28.028,7.607 36.036,22.422 3.603,6.406 5.605,13.213 5.605,20.019 0,3.804 -0.6,7.207 -1.601,10.411 -6.006,23.022 -17.418,38.037 -34.434,44.844 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path105"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g105"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 292.79901,
    y: 278.63339,
    id: "use105"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 14361.755,-15027.011 c 21.822,0 35.635,-10.61 41.641,-32.031 l 5.606,-20.821 c 1.601,-4.204 2.402,-8.208 2.402,-12.012 0,-13.213 -8.809,-20.019 -26.426,-20.019 h -32.832 l -14.415,52.852 c -0.6,3.203 -0.8,6.006 -0.8,8.008 0,7.007 2.402,12.812 7.207,17.617 4.805,4.404 10.61,6.406 17.617,6.406 z m -5.605,20.821 c -15.015,0 -26.827,-7.608 -35.235,-23.223 -3.804,-6.807 -5.606,-13.814 -5.606,-20.821 0,-2.602 0.201,-5.605 0.801,-8.808 l 16.817,-63.263 c 6.406,-23.423 17.017,-43.242 32.031,-59.258 16.416,-17.617 38.038,-29.629 64.864,-36.035 0.401,0 1.201,0 2.403,0 6.806,0 10.41,3.603 10.41,10.41 0,6.006 -2.403,9.409 -7.207,10.41 -11.812,1.602 -23.624,6.006 -35.235,12.813 -21.421,13.413 -35.034,30.43 -40.84,51.25 h 31.231 c 12.212,0 22.422,3.804 30.43,11.211 8.007,7.608 12.011,17.417 12.011,29.629 0,4.405 -0.6,8.409 -1.601,12.012 l -5.606,20.821 c -7.007,24.624 -19.018,40.44 -36.035,47.246 -9.209,3.804 -20.42,5.606 -33.633,5.606 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path106"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g106"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 292.79901,
    y: 281.51334,
    id: "use106"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 14577.368,-15110.293 -61.661,99.298 c -1.602,3.203 -4.605,4.805 -8.809,4.805 -2.803,0 -5.205,-1.001 -7.207,-3.203 -2.202,-2.002 -3.203,-4.805 -3.203,-8.008 l 7.207,-189.787 c 0,-6.807 3.403,-10.41 10.41,-10.41 7.408,0 11.211,3.803 11.211,11.211 l -6.406,150.548 56.856,-92.892 c 2.002,-3.603 5.005,-5.605 8.809,-5.605 6.806,0 10.61,3.203 11.211,9.609 l 6.406,89.689 77.677,-156.955 c 2.002,-3.603 5.205,-5.605 9.609,-5.605 6.807,0 10.41,3.603 10.41,10.41 0,1.601 -0.4,3.203 -0.8,4.805 l -94.494,190.587 c -2.202,3.804 -5.405,5.606 -9.609,5.606 -7.007,0 -10.41,-3.203 -10.41,-9.61 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path107"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g107"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 292.91806,
    y: 290.03613,
    id: "use107"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 14987.772,-15033.017 c 6.807,0 10.41,3.604 10.41,10.411 0,7.007 -3.603,10.41 -10.41,10.41 h -90.489 c -3.203,0 -5.606,-1.001 -7.207,-3.203 -1.602,-2.002 -2.002,-4.405 -0.801,-7.207 l 52.051,-192.99 c 1.001,-5.206 4.205,-8.008 9.61,-8.008 6.807,0 10.41,3.603 10.41,10.41 0,1.201 0,2.202 0,3.203 l -47.246,176.974 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path108"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g108"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 292.91806,
    y: 293.03128,
    id: "use108"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15147.73,-15117.9 h -57.657 l -22.422,84.883 h 73.672 c 6.807,0 10.411,3.604 10.411,10.411 0,7.007 -3.604,10.41 -10.411,10.41 h -90.489 c -3.203,0 -5.605,-1.001 -7.207,-3.203 -1.601,-2.002 -2.002,-4.405 -0.801,-7.207 l 51.251,-190.588 c 1.602,-6.807 6.006,-10.41 13.613,-10.41 h 84.083 c 7.408,0 11.211,3.603 11.211,10.41 0,7.007 -3.803,10.41 -11.211,10.41 h -79.278 l -16.816,64.063 h 52.051 c 6.807,0 10.41,3.604 10.41,10.411 0,7.006 -3.603,10.41 -10.41,10.41 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path109"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g109"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 292.91806,
    y: 295.91125,
    id: "use109"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15241.622,-15213.194 c 1.602,-6.807 6.006,-10.41 13.614,-10.41 h 65.664 c 11.212,0 20.821,4.804 28.829,14.414 8.408,9.209 12.813,19.219 12.813,30.43 0,2.803 -0.401,5.405 -0.801,8.008 l -28.829,105.704 c -9.609,35.235 -32.632,52.852 -68.868,52.852 h -65.664 c -3.203,0 -5.606,-1.001 -7.207,-3.203 -1.602,-2.002 -2.002,-4.405 -0.801,-7.207 z m 18.419,10.41 -44.845,169.767 h 54.454 c 9.009,0 17.617,-2.802 25.625,-8.808 8.008,-6.407 13.213,-14.014 16.016,-23.223 l 28.028,-105.704 c 1.001,-2.603 1.601,-5.205 1.601,-8.008 0,-6.807 -2.803,-12.412 -8.008,-16.817 -4.804,-4.804 -10.81,-7.207 -17.617,-7.207 z m 0,0",
    transform: "matrix(0,0.019512,-0.019512,0,0,-4e-6)",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 396.16146,386.88021 v 14.07813 h -5.92188 v -14.07813 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-6.04667e-4 2.878113,-0.162063 5.602071,-0.79748 l 2.71875,-0.802083 2.71875,-1.28125 2.239584,-1.598958 2.239583,-1.921875 1.921875,-2.239584 1.598958,-2.401041 1.28125,-2.557292 0.796875,-2.71875 0.640625,-2.723958 0.161459,-2.880209 -0.161459,-2.875 -0.640625,-2.723958 -0.796875,-2.71875 -1.28125,-2.71875 -1.598958,-2.239583 -1.921875,-2.239584 -2.239583,-1.921875 -2.239584,-1.598958 -2.71875,-1.28125 -2.71875,-0.802083 -2.723958,-0.635417 -2.88020833,-0.161458 -2.88020867,0.161458 -2.71875,0.635417 -2.71875,0.802083 -2.5625,1.28125 -2.395833,1.598958 -2.239583,1.921875 -1.921875,2.239584 -1.598959,2.239583 -1.28125,2.71875 -0.802083,2.71875 -0.640625,2.723958 -0.15625,2.875 0.15625,2.880209 0.640625,2.723958 0.802083,2.71875 1.28125,2.557292 1.598959,2.401041 1.921875,2.239584 2.239583,1.921875 2.395833,1.598958 2.5625,1.28125 2.71875,0.802083 2.71875,0.635417 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,332.40001,380.51999)",
    id: "path112"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g112"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-0",
    x: 329.51901,
    y: 355.5593,
    id: "use112"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g113"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 329.51901,
    y: 360.12888,
    id: "use113"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g114"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 329.51901,
    y: 364.69849,
    id: "use114"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g115"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 329.51901,
    y: 369.26807,
    id: "use115"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,-6.04667e-4 2.879364,-0.162063 l 2.71875,-0.635417 2.723958,-0.802083 2.71875,-1.28125 2.239584,-1.598958 2.239583,-1.921875 1.921875,-2.239584 1.598958,-2.401041 1.28125,-2.557292 0.796875,-2.71875 0.640625,-2.723958 0.161459,-2.880209 -0.161459,-2.875 -0.640625,-2.723958 -0.796875,-2.71875 -1.28125,-2.71875 -1.598958,-2.239583 -1.921875,-2.239584 -2.239583,-1.921875 -2.239584,-1.598958 -2.71875,-1.28125 -2.723958,-0.802083 -2.71875,-0.635417 -2.880208333,-0.161458 -2.880208667,0.161458 -2.71875,0.635417 -2.71875,0.802083 -2.5625,1.28125 -2.401041,1.598958 -2.239584,1.921875 -1.916666,2.239584 -1.604167,2.239583 -1.276042,2.71875 -0.802083,2.71875 -0.640625,2.723958 -0.15625,2.875 0.15625,2.880209 0.640625,2.723958 0.802083,2.71875 1.276042,2.557292 1.604167,2.401041 1.916666,2.239584 2.239584,1.921875 2.401041,1.598958 2.5625,1.28125 2.71875,0.802083 2.71875,0.635417 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,246.36001,380.51999)",
    id: "path115"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g116"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-0",
    x: 243.36072,
    y: 355.5593,
    id: "use116"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g117"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 243.36072,
    y: 360.12888,
    id: "use117"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g118"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 243.36072,
    y: 364.69849,
    id: "use118"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g119"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 243.36072,
    y: 369.26807,
    id: "use119"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,59.838547 v -1.276042 h 62.72396 v 62.718755 h -62.72396 v -1.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,59.838547 h 58.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,62.562505 -0.15625,-0.640625 -0.16146,-0.802083 -0.95833,-0.958333 -0.80209,-0.161459 -0.64062,-0.161458",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 469.4375,62.562505 V 117.43751",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.71875,120.16146 0.64062,-0.16145 0.80209,-0.16146 0.47916,-0.47917 0.47917,-0.64062 0.16146,-0.64063 0.15625,-0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 466.71875,120.16146 H 407.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,4.2e-4 0.639171,-0.640205 1.118337,-1.28083 1.441254,-2.239163 1.597504,-3.041247 1.441254,-3.838122 1.118337,-4.801663 0.639171,-5.442288 -0.00145433,-6.077705",
    transform: "matrix(0.75,0,0,0.75,305.88,49.319998)",
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.001449 0.639171,-0.642074 1.118337,-1.277491 1.441254,-2.241032 1.597504,-3.037907 1.441254,-3.839991 1.118337,-4.798324 0.639171,-5.438949 -0.00145433,-6.079574",
    transform: "matrix(0.75,0,0,0.75,305.88,53.879993)",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00188233 0.639171,-0.638743 1.118337,-1.279368 1.441254,-2.237701 1.597504,-3.039784 1.441254,-3.841868 1.118337,-4.800201 0.639171,-5.440826 -0.00145433,-6.081451",
    transform: "matrix(0.75,0,0,0.75,305.88,58.439995)",
    id: "path127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,5.33333e-6 0.639171,-0.64062 1.118337,-1.281245 1.441254,-2.239578 1.597504,-3.041661 1.441254,-3.838536 1.118337,-4.802078 0.639171,-5.437495 -0.00145433,-6.07812",
    transform: "matrix(0.75,0,0,0.75,305.88,62.999996)",
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00188233 0.639171,-0.638743 1.118337,-1.279368 1.441254,-2.237701 1.597504,-3.039784 1.441254,-3.841868 1.118337,-4.800201 0.639171,-5.440826 -0.00145433,-6.081451",
    transform: "matrix(0.75,0,0,0.75,305.88,67.439995)",
    id: "path129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,5.33333e-6 0.639171,-0.64062 1.118337,-1.281245 1.441254,-2.239578 1.597504,-3.041661 1.441254,-3.838536 1.118337,-4.802078 0.639171,-5.437495 -0.00145433,-6.07812",
    transform: "matrix(0.75,0,0,0.75,305.88,71.999996)",
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00187167 0.639171,-0.642497 1.118337,-1.277913 1.441254,-2.241455 1.597504,-3.03833 1.441254,-3.840413 1.118337,-4.798747 0.639171,-5.439372 -0.00145433,-6.079997",
    transform: "matrix(0.75,0,0,0.75,305.88,76.559998)",
    id: "path131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00145967 0.639171,-0.639165 1.118337,-1.27979 1.441254,-2.238124 1.597504,-3.040207 1.441254,-3.84229 1.118337,-4.800624 0.639171,-5.441249 -0.00145433,-6.081874",
    transform: "matrix(0.75,0,0,0.75,305.88,81.119999)",
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00187167 0.639171,-0.642497 1.118337,-1.277913 1.441254,-2.241455 1.597504,-3.03833 1.441254,-3.840413 1.118337,-4.798747 0.639171,-5.439372 -0.00145433,-6.079997",
    transform: "matrix(0.75,0,0,0.75,305.88,85.559998)",
    id: "path133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00145967 0.639171,-0.639165 1.118337,-1.27979 1.441254,-2.238124 1.597504,-3.040207 1.441254,-3.84229 1.118337,-4.800624 0.639171,-5.441249 -0.00145433,-6.081874",
    transform: "matrix(0.75,0,0,0.75,305.88,90.119999)",
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,4.2e-4 1.125,-0.161458 0.958333,-0.479167 0.796875,-0.640625 0.640625,-0.958333 0.322917,-1.119792 V -4.322497 L 3.518331,-5.442288 2.877706,-6.400622 2.080831,-7.041247 1.122498,-7.520413 l -1.125,-0.161459 -1.119792,0.161459 -0.958333,0.479166 -0.796875,0.640625 -0.640625,0.958334 -0.322917,1.119791 v 0.963542 l 0.322917,1.119792 0.640625,0.958333 0.796875,0.640625 0.958333,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,328.08,70.319998)",
    id: "path135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.31771,87.197922 -5.59896,5.604167 m 0,-5.604167 5.59896,5.604167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,122.56251 v -1.28125 H 470.5625 V 184 h -62.72396 v -1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,122.56251 h 58.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,125.28126 -0.15625,-0.64063 -0.16146,-0.80208 -0.95833,-0.95834 -0.80209,-0.16145 -0.64062,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,125.28126 v 54.8802",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.71875,182.88021 0.64062,-0.16146 0.80209,-0.15625 0.47916,-0.48437 0.47917,-0.64063 0.16146,-0.63541 0.15625,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 466.71875,182.88021 H 407.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,6.31333e-4 0.639171,-0.639994 1.118337,-1.280619 1.441254,-2.238952 1.597504,-3.041035 1.441254,-3.83791 1.118337,-4.801452 0.639171,-5.442077 -0.00145433,-6.077494",
    transform: "matrix(0.75,0,0,0.75,305.88,96.479995)",
    id: "path143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00250733 0.639171,-0.638118 1.118337,-1.278743 1.441254,-2.242284 1.597504,-3.039159 1.441254,-3.841243 1.118337,-4.799576 0.639171,-5.440201 -0.00145433,-6.080826",
    transform: "matrix(0.75,0,0,0.75,305.88,100.92)",
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,6.31333e-4 0.639171,-0.639994 1.118337,-1.280619 1.441254,-2.238952 1.597504,-3.041035 1.441254,-3.83791 1.118337,-4.801452 0.639171,-5.442077 -0.00145433,-6.077494",
    transform: "matrix(0.75,0,0,0.75,305.88,105.48)",
    id: "path145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00124567 0.639171,-0.641871 1.118337,-1.282496 1.441254,-2.240829 1.597504,-3.037704 1.441254,-3.839787 1.118337,-4.798121 0.639171,-5.438746 -0.00145433,-6.079371",
    transform: "matrix(0.75,0,0,0.75,305.88,110.04)",
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,6.31333e-4 0.639171,-0.639994 1.118337,-1.280619 1.441254,-2.238952 1.597504,-3.041035 1.441254,-3.83791 1.118337,-4.801452 0.639171,-5.442077 -0.00145433,-6.077494",
    transform: "matrix(0.75,0,0,0.75,305.88,114.48)",
    id: "path147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00124567 0.639171,-0.641871 1.118337,-1.282496 1.441254,-2.240829 1.597504,-3.037704 1.441254,-3.839787 1.118337,-4.798121 0.639171,-5.438746 -0.00145433,-6.079371",
    transform: "matrix(0.75,0,0,0.75,305.88,119.04)",
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00208567 0.639171,-0.638539 1.118337,-1.279164 1.441254,-2.237498 1.597504,-3.039581 1.441254,-3.841664 1.118337,-4.799998 0.639171,-5.440623 -0.00145433,-6.081248",
    transform: "matrix(0.75,0,0,0.75,305.88,123.6)",
    id: "path149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,2.08667e-4 0.639171,-0.640416 1.118337,-1.281041 1.441254,-2.239375 1.597504,-3.041458 1.441254,-3.838333 1.118337,-4.801875 0.639171,-5.4425 -0.00145433,-6.077916",
    transform: "matrix(0.75,0,0,0.75,305.88,128.16)",
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00208567 0.639171,-0.638539 1.118337,-1.279164 1.441254,-2.237498 1.597504,-3.039581 1.441254,-3.841664 1.118337,-4.799998 0.639171,-5.440623 -0.00145433,-6.081248",
    transform: "matrix(0.75,0,0,0.75,305.88,132.6)",
    id: "path151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,2.08667e-4 0.639171,-0.640416 1.118337,-1.281041 1.441254,-2.239375 1.597504,-3.041458 1.441254,-3.838333 1.118337,-4.801875 0.639171,-5.4425 -0.00145433,-6.077916",
    transform: "matrix(0.75,0,0,0.75,305.88,137.16)",
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,-8.24e-4 1.125,-0.161458 0.958333,-0.479167 0.796875,-0.640625 0.640625,-0.958333 0.322917,-1.119792 V -4.318532 L 3.518331,-5.438324 2.877706,-6.401866 2.080831,-7.042491 1.122498,-7.521657 l -1.125,-0.15625 -1.119792,0.15625 -0.958333,0.479166 -0.796875,0.640625 -0.640625,0.963542 -0.322917,1.119792 v 0.958333 l 0.322917,1.119792 0.640625,0.958333 0.796875,0.640625 0.958333,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,328.08,117.35999)",
    id: "path153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.31771,149.92188 -5.59896,5.59896 m 0,-5.59896 5.59896,5.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 407.83854,185.28125 V 184 h 62.72396 v 62.88021 h -62.72396 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,185.28125 h 58.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,188 -0.15625,-0.64062 -0.16146,-0.79688 -0.47917,-0.48437 -0.47916,-0.47917 -0.80209,-0.16146 -0.64062,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,188 v 54.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.71875,245.59896 0.64062,-0.16146 0.80209,-0.15625 0.47916,-0.47916 0.47917,-0.64063 0.16146,-0.64062 0.15625,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path159"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 466.71875,245.59896 H 407.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-6.20667e-4 0.639171,-0.641246 1.118337,-1.281871 1.441254,-2.240204 1.597504,-3.042287 1.441254,-3.839162 1.118337,-4.797496 0.639171,-5.438121 -0.00145433,-6.078746",
    transform: "matrix(0.75,0,0,0.75,305.88,143.52)",
    id: "path161"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00125633 0.639171,-0.639369 1.118337,-1.279994 1.441254,-2.238327 1.597504,-3.04041 1.441254,-3.842494 1.118337,-4.800827 0.639171,-5.441452 -0.00145433,-6.082077",
    transform: "matrix(0.75,0,0,0.75,305.88,147.95999)",
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-6.20667e-4 0.639171,-0.641246 1.118337,-1.281871 1.441254,-2.240204 1.597504,-3.042287 1.441254,-3.839162 1.118337,-4.797496 0.639171,-5.438121 -0.00145433,-6.078746",
    transform: "matrix(0.75,0,0,0.75,305.88,152.52)",
    id: "path163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00249667 0.639171,-0.637913 1.118337,-1.278538 1.441254,-2.24208 1.597504,-3.038955 1.441254,-3.841038 1.118337,-4.799372 0.639171,-5.439997 -0.00145433,-6.080622",
    transform: "matrix(0.75,0,0,0.75,305.88,157.08)",
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,8.34667e-4 0.639171,-0.63979 1.118337,-1.280415 1.441254,-2.238749 1.597504,-3.040832 1.441254,-3.837707 1.118337,-4.801249 0.639171,-5.441874 -0.00145433,-6.082499",
    transform: "matrix(0.75,0,0,0.75,305.88,161.64)",
    id: "path165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00249667 0.639171,-0.637913 1.118337,-1.278538 1.441254,-2.24208 1.597504,-3.038955 1.441254,-3.841038 1.118337,-4.799372 0.639171,-5.439997 -0.00145433,-6.080622",
    transform: "matrix(0.75,0,0,0.75,305.88,166.08)",
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,8.34667e-4 0.639171,-0.63979 1.118337,-1.280415 1.441254,-2.238749 1.597504,-3.040832 1.441254,-3.837707 1.118337,-4.801249 0.639171,-5.441874 -0.00145433,-6.082499",
    transform: "matrix(0.75,0,0,0.75,305.88,170.64)",
    id: "path167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00104233 0.639171,-0.641667 1.118337,-1.282292 1.441254,-2.240626 1.597504,-3.037501 1.441254,-3.839584 1.118337,-4.797917 0.639171,-5.438542 -0.00145433,-6.079167",
    transform: "matrix(0.75,0,0,0.75,305.88,175.2)",
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.002304 0.639171,-0.638321 1.118337,-1.278946 1.441254,-2.242488 1.597504,-3.039363 1.441254,-3.841446 1.118337,-4.799779 0.639171,-5.440404 -0.00145433,-6.081029",
    transform: "matrix(0.75,0,0,0.75,305.88,179.75999)",
    id: "path169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00104233 0.639171,-0.641667 1.118337,-1.282292 1.441254,-2.240626 1.597504,-3.037501 1.441254,-3.839584 1.118337,-4.797917 0.639171,-5.438542 -0.00145433,-6.079167",
    transform: "matrix(0.75,0,0,0.75,305.88,184.2)",
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,-0.002075 1.125,-0.15625 0.958333,-0.479167 0.796875,-0.640625 0.640625,-0.963541 0.322917,-1.119792 V -4.319783 L 3.518331,-5.439575 2.877706,-6.397908 2.080831,-7.038533 1.122498,-7.5177 l -1.125,-0.161458 -1.119792,0.161458 -0.958333,0.479167 -0.796875,0.640625 -0.640625,0.958333 -0.322917,1.119792 v 0.958333 l 0.322917,1.119792 0.640625,0.963541 0.796875,0.640625 0.958333,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,328.08,164.39999)",
    id: "path171"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.31771,212.64063 -5.59896,5.59896 m 0,-5.59896 5.59896,5.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,248 v -1.11979 h 62.72396 v 62.71875 h -62.72396 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,248 h 58.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,250.71875 -0.15625,-0.64062 -0.16146,-0.79688 -0.47917,-0.47916 -0.47916,-0.48438 -0.80209,-0.15625 L 466.71875,248",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,250.71875 v 54.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.71875,308.31771 0.64062,-0.15625 0.80209,-0.16146 0.47916,-0.47916 0.47917,-0.64063 0.16146,-0.64062 0.15625,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 466.71875,308.31771 H 407.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00187167 0.639171,-0.642497 1.118337,-1.277913 1.441254,-2.241455 1.597504,-3.03833 1.441254,-3.840413 1.118337,-4.798747 0.639171,-5.439372 -0.00145433,-6.079997",
    transform: "matrix(0.75,0,0,0.75,305.88,190.56)",
    id: "path179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,5.33333e-6 0.639171,-0.64062 1.118337,-1.281245 1.441254,-2.239578 1.597504,-3.041661 1.441254,-3.838536 1.118337,-4.802078 0.639171,-5.437495 -0.00145433,-6.07812",
    transform: "matrix(0.75,0,0,0.75,305.88,195)",
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00185667 0.639171,-0.642482 1.118337,-1.277898 1.441254,-2.24144 1.597504,-3.038315 1.441254,-3.840398 1.118337,-4.798732 0.639171,-5.439357 -0.00145433,-6.079982",
    transform: "matrix(0.75,0,0,0.75,305.88,199.55999)",
    id: "path181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00145967 0.639171,-0.639165 1.118337,-1.27979 1.441254,-2.238124 1.597504,-3.040207 1.441254,-3.84229 1.118337,-4.800624 0.639171,-5.441249 -0.00145433,-6.081874",
    transform: "matrix(0.75,0,0,0.75,305.88,204.12)",
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-4.01333e-4 0.639171,-0.641026 1.118337,-1.281651 1.441254,-2.239985 1.597504,-3.042068 1.441254,-3.838943 1.118337,-4.802485 0.639171,-5.437901 -0.00145433,-6.078526",
    transform: "matrix(0.75,0,0,0.75,305.88,208.67999)",
    id: "path183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00145967 0.639171,-0.639165 1.118337,-1.27979 1.441254,-2.238124 1.597504,-3.040207 1.441254,-3.84229 1.118337,-4.800624 0.639171,-5.441249 -0.00145433,-6.081874",
    transform: "matrix(0.75,0,0,0.75,305.88,213.12)",
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-4.01333e-4 0.639171,-0.641026 1.118337,-1.281651 1.441254,-2.239985 1.597504,-3.042068 1.441254,-3.838943 1.118337,-4.802485 0.639171,-5.437901 -0.00145433,-6.078526",
    transform: "matrix(0.75,0,0,0.75,305.88,217.67999)",
    id: "path185"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00229333 0.639171,-0.63771 1.118337,-1.278335 1.441254,-2.241877 1.597504,-3.038752 1.441254,-3.840835 1.118337,-4.799168 0.639171,-5.439793 -0.00145433,-6.080418",
    transform: "matrix(0.75,0,0,0.75,305.88,222.24)",
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.001053 0.639171,-0.639572 1.118337,-1.280197 1.441254,-2.23853 1.597504,-3.040614 1.441254,-3.837489 1.118337,-4.80103 0.639171,-5.441655 -0.00145433,-6.08228",
    transform: "matrix(0.75,0,0,0.75,305.88,226.79999)",
    id: "path187"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00229333 0.639171,-0.63771 1.118337,-1.278335 1.441254,-2.241877 1.597504,-3.038752 1.441254,-3.840835 1.118337,-4.799168 0.639171,-5.439793 -0.00145433,-6.080418",
    transform: "matrix(0.75,0,0,0.75,305.88,231.24)",
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,-0.00185667 1.122498,-0.158107 2.080831,-0.642482 2.877706,-1.277898 3.518331,-2.24144 3.841248,-3.361232 V -4.319565 L 3.518331,-5.439357 2.877706,-6.39769 2.080831,-7.038315 1.122498,-7.517482 l -1.125,-0.161458 -1.119792,0.161458 -0.958333,0.479167 -0.796875,0.640625 -0.640625,0.958333 -0.322917,1.119792 v 0.958333 l 0.322917,1.119792 0.640625,0.963542 0.796875,0.635416 0.958333,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,328.08,211.55999)",
    id: "path189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.31771,275.35938 -5.59896,5.59896 m 0,-5.59896 5.59896,5.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,310.71875 v -1.11979 h 62.72396 v 62.71875 h -62.72396 v -1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,310.71875 h 58.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,313.4375 -0.15625,-0.63541 -0.16146,-0.80209 -0.95833,-0.95833 -0.80209,-0.16146 -0.64062,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path193"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,313.4375 v 54.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.71875,371.04167 0.64062,-0.16146 0.80209,-0.16146 0.47916,-0.47916 0.47917,-0.64063 0.16146,-0.64062 0.15625,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 466.71875,371.04167 H 407.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00210067 0.639171,-0.638524 1.118337,-1.279149 1.441254,-2.237483 1.597504,-3.039566 1.441254,-3.841649 1.118337,-4.799983 0.639171,-5.440608 -0.00145433,-6.081233",
    transform: "matrix(0.75,0,0,0.75,305.88,237.59999)",
    id: "path197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,2.08667e-4 0.639171,-0.640416 1.118337,-1.281041 1.441254,-2.239375 1.597504,-3.041458 1.441254,-3.838333 1.118337,-4.801875 0.639171,-5.4425 -0.00145433,-6.077916",
    transform: "matrix(0.75,0,0,0.75,305.88,242.16)",
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00210067 0.639171,-0.638524 1.118337,-1.279149 1.441254,-2.237483 1.597504,-3.039566 1.441254,-3.841649 1.118337,-4.799983 0.639171,-5.440608 -0.00145433,-6.081233",
    transform: "matrix(0.75,0,0,0.75,305.88,246.59999)",
    id: "path199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,2.08667e-4 0.639171,-0.640416 1.118337,-1.281041 1.441254,-2.239375 1.597504,-3.041458 1.441254,-3.838333 1.118337,-4.801875 0.639171,-5.4425 -0.00145433,-6.077916",
    transform: "matrix(0.75,0,0,0.75,305.88,251.16)",
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00165233 0.639171,-0.642277 1.118337,-1.277694 1.441254,-2.241236 1.597504,-3.038111 1.441254,-3.840194 1.118337,-4.798527 0.639171,-5.439152 -0.00145433,-6.079777",
    transform: "matrix(0.75,0,0,0.75,305.88,255.71999)",
    id: "path201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.001663 0.639171,-0.638962 1.118337,-1.279587 1.441254,-2.23792 1.597504,-3.040004 1.441254,-3.842087 1.118337,-4.80042 0.639171,-5.441045 -0.00145433,-6.08167",
    transform: "matrix(0.75,0,0,0.75,305.88,260.28)",
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00165233 0.639171,-0.642277 1.118337,-1.277694 1.441254,-2.241236 1.597504,-3.038111 1.441254,-3.840194 1.118337,-4.798527 0.639171,-5.439152 -0.00145433,-6.079777",
    transform: "matrix(0.75,0,0,0.75,305.88,264.71999)",
    id: "path203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.001663 0.639171,-0.638962 1.118337,-1.279587 1.441254,-2.23792 1.597504,-3.040004 1.441254,-3.842087 1.118337,-4.80042 0.639171,-5.441045 -0.00145433,-6.08167",
    transform: "matrix(0.75,0,0,0.75,305.88,269.28)",
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-1.98e-4 0.639171,-0.640823 1.118337,-1.281448 1.441254,-2.239781 1.597504,-3.041865 1.441254,-3.83874 1.118337,-4.802281 0.639171,-5.437698 -0.00145433,-6.078323",
    transform: "matrix(0.75,0,0,0.75,305.88,273.83999)",
    id: "path205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.001663 0.639171,-0.638962 1.118337,-1.279587 1.441254,-2.23792 1.597504,-3.040004 1.441254,-3.842087 1.118337,-4.80042 0.639171,-5.441045 -0.00145433,-6.08167",
    transform: "matrix(0.75,0,0,0.75,305.88,278.28)",
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,0.00210067 1.125,-0.16145867 0.958333,-0.479166 0.796875,-0.640625 0.640625,-0.958334 0.322917,-1.125 V -4.320816 L 3.518331,-5.440608 2.877706,-6.398941 2.080831,-7.039566 1.122498,-7.518733 l -1.125,-0.161458 -1.119792,0.161458 -0.958333,0.479167 -0.796875,0.640625 -0.640625,0.958333 -0.322917,1.119792 v 0.958333 l 0.322917,1.125 0.640625,0.958334 0.796875,0.640625 0.958333,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,328.08,258.59999)",
    id: "path207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.31771,338.07813 -5.59896,5.60417 m 0,-5.60417 5.59896,5.60417",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,373.4375 v -1.11979 h 62.72396 v 62.72396 h -62.72396 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 407.83854,373.4375 h 58.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,376.16146 -0.15625,-0.64062 -0.16146,-0.80209 -0.95833,-0.95833 -0.80209,-0.16146 -0.64062,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.4375,376.16146 v 54.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.71875,433.76042 0.64062,-0.16146 0.80209,-0.16146 0.47916,-0.47916 0.47917,-0.64063 0.16146,-0.63541 0.15625,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 466.71875,433.76042 H 407.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,8.49667e-4 0.639171,-0.639775 1.118337,-1.2804 1.441254,-2.238734 1.597504,-3.040817 1.441254,-3.837692 1.118337,-4.801234 0.639171,-5.441859 -0.00145433,-6.082484",
    transform: "matrix(0.75,0,0,0.75,305.88,284.63999)",
    id: "path215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00104233 0.639171,-0.641667 1.118337,-1.282292 1.441254,-2.240626 1.597504,-3.037501 1.441254,-3.839584 1.118337,-4.797917 0.639171,-5.438542 -0.00145433,-6.079167",
    transform: "matrix(0.75,0,0,0.75,305.88,289.2)",
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,8.49667e-4 0.639171,-0.639775 1.118337,-1.2804 1.441254,-2.238734 1.597504,-3.040817 1.441254,-3.837692 1.118337,-4.801234 0.639171,-5.441859 -0.00145433,-6.082484",
    transform: "matrix(0.75,0,0,0.75,305.88,293.63999)",
    id: "path217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00104233 0.639171,-0.641667 1.118337,-1.282292 1.441254,-2.240626 1.597504,-3.037501 1.441254,-3.839584 1.118337,-4.797917 0.639171,-5.438542 -0.00145433,-6.079167",
    transform: "matrix(0.75,0,0,0.75,305.88,298.2)",
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.002304 0.639171,-0.638321 1.118337,-1.278946 1.441254,-2.242488 1.597504,-3.039363 1.441254,-3.841446 1.118337,-4.799779 0.639171,-5.440404 -0.00145433,-6.081029",
    transform: "matrix(0.75,0,0,0.75,305.88,302.75999)",
    id: "path219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,4.12e-4 0.639171,-0.640213 1.118337,-1.280838 1.441254,-2.239171 1.597504,-3.041255 1.441254,-3.83813 1.118337,-4.801671 0.639171,-5.442296 -0.00145433,-6.077713",
    transform: "matrix(0.75,0,0,0.75,305.88,307.32)",
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.002304 0.639171,-0.638321 1.118337,-1.278946 1.441254,-2.242488 1.597504,-3.039363 1.441254,-3.841446 1.118337,-4.799779 0.639171,-5.440404 -0.00145433,-6.081029",
    transform: "matrix(0.75,0,0,0.75,305.88,311.75999)",
    id: "path221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,4.12e-4 0.639171,-0.640213 1.118337,-1.280838 1.441254,-2.239171 1.597504,-3.041255 1.441254,-3.83813 1.118337,-4.801671 0.639171,-5.442296 -0.00145433,-6.077713",
    transform: "matrix(0.75,0,0,0.75,305.88,316.32)",
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.001449 0.639171,-0.642074 1.118337,-1.277491 1.441254,-2.241032 1.597504,-3.037907 1.441254,-3.839991 1.118337,-4.798324 0.639171,-5.438949 -0.00145433,-6.079574",
    transform: "matrix(0.75,0,0,0.75,305.88,320.87999)",
    id: "path223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00186733 0.639171,-0.638758 1.118337,-1.279383 1.441254,-2.237716 1.597504,-3.039799 1.441254,-3.841883 1.118337,-4.800216 0.639171,-5.440841 -0.00145433,-6.081466",
    transform: "matrix(0.75,0,0,0.75,305.88,325.44001)",
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,8.49667e-4 1.122498,-0.160609 2.080831,-0.639775 2.877706,-1.2804 3.518331,-2.238734 3.841248,-3.358525 V -4.322067 L 3.518331,-5.441859 2.877706,-6.400192 2.080831,-7.040817 1.122498,-7.519984 l -1.125,-0.161458 -1.119792,0.161458 -0.958333,0.479167 -0.796875,0.640625 -0.640625,0.958333 -0.322917,1.119792 v 0.963542 l 0.322917,1.119791 0.640625,0.958334 0.796875,0.640625 0.958333,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,328.08,305.63999)",
    id: "path225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.31771,400.80209 -5.59896,5.59896 m 0,-5.59896 5.59896,5.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 343.68229,199.35938 V 372 H 300.64062 V 199.35938 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 339.04167,240.64063 0.64062,-0.16146 0.79688,-0.16146 0.47916,-0.47916 0.47917,-0.64063 0.16146,-0.63542 0.16146,-0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 339.04167,240.64063 H 313.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.40104,237.92188 0.16146,0.64062 0.15625,0.63542 0.47917,0.64063 0.64062,0.47916 1.28125,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 310.40104,237.92188 V 204.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 313.11979,201.4375 -1.28125,0.32292 -0.64062,0.47917 -0.47917,0.47916 -0.15625,0.80209 -0.16146,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 313.11979,201.4375 h 25.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.76042,204.16146 -0.16146,-0.64062 -0.16146,-0.80209 -0.95833,-0.95833 -0.79688,-0.16146 -0.64062,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.76042,204.16146 v 33.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,0.00208567 1.117493,-0.159373 2.081035,-0.638539 2.87791,-1.279164 l 0.640625,-0.958334 0.322916,-1.125 V -4.320831 L 3.518535,-5.440623 2.87791,-6.398956 2.081035,-7.039581 1.117493,-7.518748 -0.00229867,-7.680206 -1.12209,-7.518748 l -0.958334,0.479167 -0.802083,0.640625 -0.635417,0.958333 -0.322916,1.119792 v 0.958333 l 0.322916,1.125 0.635417,0.958334 0.802083,0.640625 0.958334,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,243.24,168.6)",
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 327.19792,218.23959 -5.59896,5.59896 m 0,-5.59896 5.59896,5.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001251,2.08667e-4 0.798126,-0.16125 l 0.484375,-0.479166 0.479167,-0.479167 0.15625,-0.802083 -0.15625,-0.796875 -0.963542,-0.963542 -0.796875,-0.15625 -0.802083,0.15625 -0.479167,0.484375 -0.479167,0.479167 -0.161458,0.796875 0.161458,0.802083 0.958334,0.958333 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,228.96,167.16)",
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 339.04167,283.6823 0.64062,-0.16146 0.79688,-0.16146 0.47916,-0.47917 0.47917,-0.64062 0.32292,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 339.04167,283.6823 H 313.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.40104,280.95834 0.16146,0.64062 0.15625,0.64063 0.47917,0.64062 0.64062,0.47917 1.28125,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 310.40104,280.95834 V 247.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 313.11979,244.47917 -1.28125,0.32292 -0.64062,0.47916 -0.47917,0.47917 -0.15625,0.80208 -0.16146,0.63542",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 313.11979,244.47917 h 25.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.76042,247.19792 -0.16146,-0.63542 -0.16146,-0.80208 -0.95833,-0.95833 -0.79688,-0.16146 -0.64062,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.76042,247.19792 v 33.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,5.33333e-6 1.117493,-0.161453 2.081035,-0.64062 2.87791,-1.281245 3.518535,-2.239578 3.841451,-3.35937 V -4.317703 L 3.518535,-5.437495 2.87791,-6.401036 2.081035,-7.041661 1.117493,-7.520828 -0.00229867,-7.682286 -1.12209,-7.520828 l -0.958334,0.479167 -0.802083,0.640625 -0.635417,0.963541 -0.322916,1.119792 v 0.958333 l 0.322916,1.119792 0.635417,0.958333 0.802083,0.640625 0.958334,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,243.24,201)",
    id: "path247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 327.19792,261.4375 -5.59896,5.44271 m 0,-5.44271 5.59896,5.44271",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001251,-0.00185667 0.798126,-0.158107 1.761668,-1.121648 1.917918,-1.918523 1.761668,-2.720607 1.282501,-3.199773 0.798126,-3.67894 0.001251,-3.840398 l -0.802083,0.161458 -0.958334,0.958333 -0.161458,0.802084 0.161458,0.796875 0.479167,0.479166 0.479167,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,228.96,199.55999)",
    id: "path249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 339.04167,326.88021 0.64062,-0.16146 0.79688,-0.15625 0.47916,-0.48437 0.47917,-0.64063 0.16146,-0.63541 0.16146,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 339.04167,326.88021 H 313.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.40104,324.16146 0.16146,0.64063 0.15625,0.63541 0.47917,0.64063 0.64062,0.48437 0.64063,0.15625 0.64062,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 310.40104,324.16146 V 290.40105",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 313.11979,287.6823 -0.64062,0.15625 -0.64063,0.16145 -0.64062,0.47917 -0.47917,0.47917 -0.15625,0.80208 -0.16146,0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 313.11979,287.6823 h 25.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path255"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.76042,290.40105 -0.16146,-0.64063 -0.16146,-0.80208 -0.95833,-0.95834 -0.79688,-0.16145 -0.64062,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.76042,290.40105 v 33.76041",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,0.001663 1.117493,-0.159795 2.081035,-0.638962 2.87791,-1.279587 3.518535,-2.23792 3.841451,-3.357712 V -4.321254 L 3.518535,-5.441045 2.87791,-6.399379 2.081035,-7.040004 1.117493,-7.51917 -0.00229867,-7.680629 -1.12209,-7.51917 l -0.958334,0.479166 -0.802083,0.640625 -0.635417,0.958334 -0.322916,1.119791 v 0.963542 l 0.322916,1.119792 0.635417,0.958333 0.802083,0.640625 0.958334,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,243.24,233.28)",
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 327.19792,304.47917 -5.59896,5.59896 m 0,-5.59896 5.59896,5.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001251,-1.98e-4 0.798126,-0.161656 1.282501,-0.640823 1.761668,-1.11999 1.917918,-1.922073 1.761668,-2.718948 0.798126,-3.68249 0.001251,-3.83874 l -0.802083,0.15625 -0.479167,0.484375 -0.479167,0.479167 -0.161458,0.796875 0.161458,0.802083 0.958334,0.958334 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,228.96,231.83999)",
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 339.04167,369.92188 0.64062,-0.16146 0.79688,-0.16146 0.47916,-0.47916 0.47917,-0.64063 0.32292,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 339.04167,369.92188 H 313.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.40104,367.19792 0.16146,0.64063 0.15625,0.64062 0.47917,0.64063 0.64062,0.47916 1.28125,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 310.40104,367.19792 V 333.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 313.11979,330.88021 -0.64062,0.16146 -0.64063,0.15625 -0.64062,0.48438 -0.47917,0.47916 -0.15625,0.79688 -0.16146,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 313.11979,330.71875 h 25.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.76042,333.59896 -0.16146,-0.64062 -0.16146,-0.79688 -0.47917,-0.47916 -0.47916,-0.48438 -0.79688,-0.15625 -0.64062,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.76042,333.59896 v 33.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-4.01333e-4 1.117493,-0.16186 2.081035,-0.641026 2.87791,-1.281651 3.518535,-2.239985 3.841451,-3.359776 V -4.31811 L 3.518535,-5.437901 2.87791,-6.401443 2.081035,-7.042068 1.117493,-7.521235 l -1.11979167,-0.15625 -1.11979133,0.15625 -0.958334,0.479167 -0.802083,0.640625 -0.635417,0.963542 -0.322916,1.119791 v 0.958334 l 0.322916,1.119791 0.635417,0.958334 0.802083,0.640625 0.958334,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,243.24,265.67999)",
    id: "path269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 327.19792,347.6823 -5.59896,5.4375 m 0,-5.4375 5.59896,5.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001251,-0.00229333 0.798126,-0.158543 1.282501,-0.63771 1.761668,-1.122085 1.917918,-1.91896 1.761668,-2.721043 1.282501,-3.20021 0.798126,-3.679377 0.001251,-3.840835 l -0.802083,0.161458 -0.958334,0.958334 -0.161458,0.802083 0.161458,0.796875 0.479167,0.484375 0.479167,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,228.96,264.24)",
    id: "path271"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/План Душовий.61bae1495a102195a419391e2e73de51.svg";
export { ForwardRef as ReactComponent };